import React, { Fragment, useEffect } from "react"
import { Box, Divider, Typography } from "@mui/material"
import Question from "./Question"
import styles from "../../Quiz.module.scss"
import { Col } from "react-bootstrap"
import ImageDisplay from "components/ImageDisplayer"
import { appActions } from "redux/app/slice/app"
import { useDispatch, useSelector } from "react-redux"
import WeeklyCategoryCard from "pages/private/learning_development/WeeklyChallenge/components/ContestDetails/weeklyCategoryCard"

function WeeklyQuizQuestions({ questions, questionCount }) {
  const dispatch = useDispatch()
  const [questionCategoryCount, setQuestionCategoryCount] = React.useState([])
  const [selectedCategory, setSelectedCategory] = React.useState("all")
  const [questionList, setQuestionsList] = React.useState([])
  const { isLoading } = useSelector((state) => state?.app)
  const allSelected = selectedCategory === "all"

  React.useEffect(() => {
    dispatch(appActions.setFilters({ category: [] }))
    if (!questionCount?.length) return
    const categoryCount = [
      { title: "All", category: "all", count: questions?.length },
      ...questionCount.map((item) => ({
        title: item.category_name,
        category: item.category_id,
        count: item.question_count
      }))
    ]

    setQuestionCategoryCount(categoryCount)
  }, [questionCount, questions])

  useEffect(() => {
    if (selectedCategory === "all") {
      setQuestionsList(questions)
    } else {
      const filtered = questions?.filter((q) => q?.category_id === selectedCategory)
      setQuestionsList(filtered)
    }
  }, [selectedCategory, questions])

  return (
    <Fragment>
      {!!questions?.length && (
        <Col lg="12" className="p-0">
          <Box className="d-flex w-100 flex-wrap">
            {questionCategoryCount?.map((option, index) => (
              <WeeklyCategoryCard
                key={index}
                title={option?.title}
                category={option?.category}
                count={option?.count}
                handleClick={() => setSelectedCategory(option?.category)}
                isIncluded={
                  allSelected ? option?.category === "all" : selectedCategory === option?.category
                }
              />
            ))}
          </Box>
        </Col>
      )}
      <Divider className={styles.divider} />
      {questionList?.length > 0 ? (
        questionList?.map((question, index) => (
          <Fragment key={question?.id}>
            <Box key={question?.id} className={`${styles.questionCtr} ${styles.box}`}>
              <Question question={question} index={index} />
              <div
                className={`me-5 p-2 d-flex align-items-center justify-content-center ${styles.imageContainer}`}>
                <ImageDisplay data={question?.image} />
              </div>
            </Box>
            {question?.id !== questions?.length && <Divider className={styles.divider} />}
          </Fragment>
        ))
      ) : (
        <Box className="d-flex justify-content-center align-items-center" height={"60vh"}>
          <Typography variant="h2" className="d-flex justify-content-center">
            {isLoading ? "Please wait, we are fetching the questions..." : "No Questions Found"}
          </Typography>
        </Box>
      )}
    </Fragment>
  )
}

export default WeeklyQuizQuestions
